module.exports = __webpack_public_path__ + "static/media/rural-innovation-centre.834d1fad.jpg";